export default function IntroductionSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Tại Sao Thương Hiệu Cá Nhân Quan Trọng?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Trong thời đại số, thương hiệu cá nhân chính là tài sản vô giá giúp bạn nổi bật, 
            tạo dấu ấn và xây dựng lòng tin với khách hàng
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/0c4387027150547209dcd99be17fd8f3.jpg"
              alt="Personal Branding"
              className="w-full h-96 object-cover rounded-3xl shadow-2xl"
            />
          </div>
          
          <div className="space-y-6">
            <div className="flex gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
                <i className="ri-user-star-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-2 text-gray-900">Tạo Dấu Ấn Riêng</h3>
                <p className="text-gray-600 leading-relaxed">
                  Thương hiệu cá nhân độc đáo giúp bạn khác biệt trong đám đông và dễ dàng được ghi nhớ bởi khách hàng tiềm năng
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
                <i className="ri-shield-check-line text-2xl text-amber-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-2 text-gray-900">Xây Dựng Uy Tín</h3>
                <p className="text-gray-600 leading-relaxed">
                  Thương hiệu cá nhân mạnh mẽ tạo niềm tin và uy tín trong lĩnh vực chuyên môn của bạn
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-rose-100 rounded-xl flex-shrink-0">
                <i className="ri-rocket-line text-2xl text-rose-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-2 text-gray-900">Tăng Cơ Hội Nghề Nghiệp</h3>
                <p className="text-gray-600 leading-relaxed">
                  Thương hiệu chuyên nghiệp mở ra nhiều cơ hội hợp tác, khách hàng và phát triển sự nghiệp
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-3xl p-12 text-white text-center shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Sẵn Sàng Khám Phá Thương Hiệu Của Bạn?
          </h3>
          <p className="text-xl mb-8 text-white/90 max-w-2xl mx-auto">
            Chỉ mất 3-5 phút để hoàn thành bài trắc nghiệm và nhận được phân tích chi tiết về phong cách thương hiệu phù hợp với bạn
          </p>
          <button
            onClick={() => {
              const quizSection = document.getElementById('quiz-section');
              if (quizSection) {
                quizSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="whitespace-nowrap px-10 py-4 bg-white text-teal-600 text-lg font-semibold rounded-full hover:bg-gray-50 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 cursor-pointer"
          >
            Bắt Đầu Ngay
          </button>
        </div>
      </div>
    </section>
  );
}